import axios from 'axios';
import { call, put, takeEvery } from 'redux-saga/effects';
import constants from 'constants';
import actions from 'actions';

const {
  addRequestError,
  addSponsors,
  startRequest,
  endRequest
} = actions;

const {
  API_SPONSORS,
  LOAD_SPONSORS_SAGA
} = constants;

const apiLoadAdminSponsors = () => (
  axios.get(API_SPONSORS)
);

function* loadSponsors({}) {
  try {
    yield put(startRequest('loading_sponsors'));

    const response = yield call(apiLoadAdminSponsors);
    const sponsors = response.data.sponsors;

    yield put(addSponsors(sponsors));
    yield put(endRequest('loading_sponsors'));

  } catch (e) {
    yield put(addRequestError(e.response))
    yield put(endRequest('loading_sponsors'));
  }
}

function* __loadSponsorsSaga() {
  yield takeEvery(LOAD_SPONSORS_SAGA, loadSponsors)
}

export {
  __loadSponsorsSaga
};



// WEBPACK FOOTER //
// ./src/sagas/sponsors.js